import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RoleChooserState, IRoleChooser } from "./roleChooserTypes";
import { isPartialTree } from "../utilities/roleHelpers";

const initialState: RoleChooserState = {
    activeRole: JSON.parse(sessionStorage.getItem('active_role') || '{}'),
    loading: false,
}

const roleChooserSlice = createSlice({
  name: 'roleChooser',
  initialState,
  reducers: {
    chooseRole: (state, action: PayloadAction<IRoleChooser>) => {
        sessionStorage.setItem('active_role', JSON.stringify(action.payload));
        state.activeRole = action.payload;
    },
    rolesLoading: (state) => {
        state.loading = true;
        state.error = undefined;
    },
    rolesLoaded: (state, action: PayloadAction<IRoleChooser>) => {
        // When roles are loaded, set both roles and activeRole to the payload if activeRole is empty
        state.roles = action.payload;
        if (!state.activeRole || Object.keys(state.activeRole).length === 0) {
            state.activeRole = action.payload;
        } else if (isPartialTree(state.activeRole, action.payload)) {
            // Keep existing activeRole if it's valid within the new roles
            state.activeRole = state.activeRole;
        } else {
            // If activeRole is invalid for new roles, reset it
            state.activeRole = action.payload;
        }
        state.loading = false;
        state.error = undefined;
    },
    rolesError: (state, action: PayloadAction<string>) => {
        state.roles = undefined;
        state.loading = false;
        state.error = action.payload;
    }
  }
});

export const { chooseRole, rolesLoading, rolesLoaded, rolesError } = roleChooserSlice.actions;
export default roleChooserSlice.reducer;